// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DataTableCssOverrides, DataTablePresentationProps, DataTableProps } from "@insite/mobius/DataTable/DataTable";
import * as React from "react";

export interface DataTableContextData
    extends Omit<DataTablePresentationProps, "cssOverrides">,
        Pick<DataTableProps, "sortOrder"> {
    /** The level to set for all section titles, appropriate for the architecture of the page. */
    _cssOverrides: DataTableCssOverrides;
    // XNG-Changes
    isMobile?: boolean;
}

const DataTableContext = React.createContext<DataTableContextData>({
    _cssOverrides: {},
    cellTypographyProps: {},
    headerTypographyProps: {},
    sortClickableProps: {},
    sortIconProps: {},
    sortIconSources: {},
    sortOrder: [],
    // XNG-Changes
    isMobile: false,
});

export default DataTableContext;
